export default {
    FINALIZADO: 'Finalizado'
}
